/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        10/01/2020      2416: Flow to NLP change
*********************************************************************************/
import { withState, Component, Link } from '@mna/react'
import IconX from 'assets/icons/x.svg'
import NLPSymptomSearch from './NLPsearch'
const Page = ({ state, actions,setState, history, previousStepName, nextStepName }) =>
    <div className="article-width flex flex-column full-height pt-2"
        style={{ maxWidth: '620px' }}
    >
        <div className="flex-grow selected-symptom-list" style={{ overflowY: 'auto' }}>
            <NLPSymptomSearch {...{ state, actions,setState, history, }} />
        </div>
    </div>
export default withState({
    didMount({ actions }) {
        actions.clearTriageQuestions()
    }
})(Page)
